import { Select } from "../components/Inputs/Select";
import { Type, Validator } from "./Type";
import { SwitchFieldComponent } from "../components/Inputs/SwitchFieldComponent";
import { Required } from "../index";

export interface SwitchOptions {
  on: {
    value: any;
    label: string | (() => string);
  };
  off: {
    value: any;
    label: string | (() => string);
  };
}

export const SwitchField = (
  options: SwitchOptions,
  ...validators: Validator[]
) => {
  const hasRequiredValidator = validators.indexOf(Required) !== -1;

  return new Type({
    // @ts-ignore
    Component: Select,
    PresentationComponent: SwitchFieldComponent as any,
    props: {
      options: [options.on, options.off],
      clearable: !hasRequiredValidator,
      parse: (v: any) => {
        if (v === "") {
          return null;
        } else {
          return v;
        }
      }
    },
    validators
  });
};
